import { DeepRequired } from 'utility-types';
import { IOrganizationSettings } from '../types/OrganizationSettings';

export const defaultOrganizationBlobSettings: DeepRequired<IOrganizationSettings> = {
  global: {
    payroll: {
      gusto: {
        isMigratedToMemberUuidsTimeStamp: null,
      },
    },
    onboardingFeatureSelections: [],
    onboardingHowTrackTimeSelections: [],
  },
  web: {
    ui: {
      requestedDocumentsAccess: false,
      requestedDailyProjectReportsAccess: false,
      requestedProgressTrackingAccess: false,
      requestedBulletinAccess: false,
      requestedSafetyReportsAccess: false,
    },
  },
};
